import axiosInstance from "../../../../../axiosInstance";
import {
  success,
  info,
  error,
  warning,
} from "../../../../../store/notification/actions";

// Add license to database.

export async function addLicense(data) {
  info("Adding new License...");
  if (data != null) {
    return await axiosInstance
      .post("/ancillary/license/addLicense", {
        store_id: data.storeid,
        user_id: data.userid,
        licenseno: data.licenseno,
        licensetype: data.licensetype,
        emaildate: data.emaildate,
        email: data.email,
        validfrom: data.validfrom,
        validto: data.validto
      })
      .then((response) => {
        if (response.data.status === "success") {
          success("License Created successfully");
          return { message: "", hasError: false, data: response.data.data };
        } else {
          error(response.data.error[0].message);
          return {
            message: response.data.error[0].message,
            hasError: true,
            data: "",
          };
        }
      })
      .catch((err) => {
        error(err.response.data.error[0].message);
        return {
          message: err.response.data.error[0].message,
          hasError: true,
          data: "",
        };
      });
  } else {
    return { message: "Internal error occurred", hasError: true, data: "" };
  }
}

// Edit license

export async function editLicense(data) {
  info("Saving License changes...");
  if (data != null) {
    return await axiosInstance
      .post("/ancillary/license/editLicense", {
        store_id: data.storeid,
        user_id: data.userid,
        licenseid: data.licenseid,
        licenseno: data.licenseno,
        licensetype: data.licensetype,
        emaildate: data.emaildate,
        email: data.email,
        validfrom: data.validfrom,
        validto: data.validto,
      })
      .then((response) => {
        if (response.data.status === "success") {
          success("License saved successfully");
          return { message: "", hasError: false, data: response.data.data };
        } else {
          error(response.data.error[0].message);
          return {
            message: response.data.error[0].message,
            hasError: true,
            data: "",
          };
        }
      })
      .catch((err) => {
        error(err.response.data.error[0].message);
        return {
          message: err.response.data.error[0].message,
          hasError: true,
          data: "",
        };
      });
  } else {
    return { message: "Internal error occurred", hasError: true, data: "" };
  }
}

// delete license

export const deleteLicense = (data) => {
  info("Deleting License...");
  return axiosInstance
    .post("/ancillary/license/deleteLicense", {
      store_id: data.storeid,
      licenseid: data.licenseid,
    })
    .then((res) => {
      if (res.data.status === "success") {
        success("License Deleted successfully");
        return { message: "", hasError: false, data: res.data.data };
      }
    })
    .catch((err) => {
      error(err.response.data.error[0].message);
      return {
        message: err.response.data.error[0].message,
        hasError: true,
        data: "",
      };
    });
};

// get licenses

export const getLicenses = (storeid) => {
  info("Loading Licenses...");
  if (storeid) {
    return axiosInstance
      .post(`/ancillary/license/getLicenses`, { store_id: storeid })
      .then((res) => {
        if (res.data.status === "success") {
          if (res.data.data.length > 0) {
            success("Loaded Successfully!!!");
          } else {
            warning("No records found !!!");
          }
          return { message: "", hasError: false, data: res.data.data };
        }
      })
      .catch((err) => {
        error(err.response.data.error[0].message);
        return {
          message: err.response.data.error[0].message,
          hasError: true,
          data: "",
        };
      });
  }
};
